<template>
  <div>
    <img src="../assets/my/2026.png" style="height:120px;"/>
    	<div id="wrapper">
    		<div id="content" style="height:690px;">
    			<p style="font-size:large; float:none;">
    				<strong>
    				    Program
    				</strong>
    			</p>
    			<p>The IDASB 2026 workshop program will be updated soon.</p>




    		</div>
    	</div>
      <footer-component></footer-component>
  </div>
</template>

<script>
  import FooterComponent from '@/components/Foot/footer.vue'

  export default {
    components: {
      FooterComponent
    }
  }
</script>

<style>
</style>
